import { h } from '@stencil/core';
import { pesIconSizes } from '@pes-ui/utils';
export const EnvironmentTooltip = ({ text }) => (h("pdp-icon-tooltip", { class: "environment__tooltip-trigger", icon: "information_stroke", iconSize: pesIconSizes.NANO, iconColor: "grey", position: "top" }, text));
